// Types
import Strategy from "app/types/Strategy";
// 
import CaseStrategyMap from "./CaseStrategy.map";
import DMSBatcheStrategyMap from './DMSBatcheStrategy.map';
import TemplateStrategyMap from './TemplateStrategy.map';
import ReportPresetStrategyMap from './ReportPresetStrategy.map';
import AIStrategyMap from './AIStrategy.map';
import EpisodeStategyMap from "./EpisodeStrategy.map";
import CalendarStrategyMap from "./CalendarStrategy.map";
import BillingAndSubscriptionsStrategyMap from "./BillingAndSubscriptionsStrategy.map";

const MixpanelStrategyMap:Record<string, Strategy> = {
  ...CaseStrategyMap,
  ...DMSBatcheStrategyMap,
  ...TemplateStrategyMap,
  ...ReportPresetStrategyMap,
  ...AIStrategyMap,
  ...EpisodeStategyMap,
  ...CalendarStrategyMap,
  ...BillingAndSubscriptionsStrategyMap
};

export default MixpanelStrategyMap;
